import React, { useState, useEffect } from "react";
import { Modal } from "react-responsive-modal";
import Scrollbar from "react-scrollbars-custom";
import CommentsList from "./TaskCommentList";
import TaskHeader from "./TaskHeader";
import TaskContent from "./TaskContent";
import TaskFooter from "./TaskFooter";
import { ReactComponent as CancelIcon } from "assets/img/icons/cancel.svg";
import classNames from "classnames";

function TodoListModal({ listTask, open, close, hide }) {
  const [scrollTo, setScrollTo] = useState(0);

  useEffect(() => {
    setTimeout(() => {
      setScrollTo(200);
    }, 2000);
  }, []);

  return (
    <Modal
      classNames={{
        modalContainer: "modalContainer",
        modal: classNames({
          topicModalContainer: true,
          hideModal: hide ? true : false,
        }),
      }}
      open={open}
      showCloseIcon={false}
      onClose={close}
    >
      <div className="postModalHeader">
        <span className="postType">Todo List Item</span>
        <span className="closeModal">
          <CancelIcon className="closeIcon" onClick={close} />
        </span>
      </div>
      <div className="todoListContent">
        <Scrollbar scrollTop={scrollTo}>
          <div className="selectedTodoListModal">
            <div className="slistContent">
              <TaskHeader listTask={listTask} />
              <TaskContent listTask={listTask} />
              <TaskFooter listTask={listTask} />
            </div>
            <CommentsList listTask={listTask} />
          </div>
        </Scrollbar>
      </div>
    </Modal>
  );
}

export default TodoListModal;
